import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import DevToolsModule from './store/DevToolsModule'
import SystemLog, { SystemLogType } from '../components/system-event-logs/models/SystemLog'
import { Notification } from 'element-ui'
import router from '../router'
import gql from 'graphql-tag'

if (process.env.NODE_ENV === 'development') {
  axios.interceptors.response.use((response: AxiosResponse) => {
    response.config['requestEnd'] = window.performance.now()
    const spentTime = response.config['requestEnd'] - response.config['requestStart']
    if (spentTime > DevToolsModule.logIfBigThan) {
      const systemLog = new SystemLog()
      systemLog.spentTime = parseInt(`${spentTime / 1000}`)
      systemLog.content = response.config.data
      systemLog.title = response.config.url
      systemLog.type = SystemLogType.requestTooLong
      systemLog.router = router.currentRoute
      DevToolsModule.addSystemLog(systemLog)
      Notification({
        title: '警告',
        dangerouslyUseHTMLString: true,
        message: `
        <div>该请求耗时不符合系统性能指标</div>
        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 220px;font-size: 12px;">请求路径：${systemLog.title}</div>
        <div>耗时【 ${systemLog.spentTime} s 】</div>
        `,
        type: 'warning'
      })
    }
    return response
  })

  axios.interceptors.request.use((config: AxiosRequestConfig) => {
    config['requestStart'] = window.performance.now()
    return config
  })
}

axios.interceptors.request.use((config: AxiosRequestConfig) => {
  try {
    const gqls = gql`
      ${config.data.query}
    `
    const requestMethods: Array<string> = new Array<string>()
    gqls.definitions.forEach((definition: any) => {
      if (definition.name) {
        requestMethods.push(definition.name.value as string)
      } else {
        definition.selectionSet.selections.forEach((selection: any) => {
          if (selection.name) {
            requestMethods.push(selection.name.value)
          }
        })
      }
    })
    config.headers['Request-Meta'] = `${config.url?.split('/').pop()}.${requestMethods.join(',')}`
  } catch (e) {
    // none
  }
  return config
})
